/**
 * Native Shopify discount code apply/remove for Discount Kit cart promo UI.
 */
(function () {
  const I18N = window.__poDiscountI18n || {};

  const FEEDBACK_KEYS = [
    'searching',
    'applied',
    'notfound',
    'notapplied',
    'notcombinable',
    'notapplied_reason',
  ];

  function getSectionsToRender() {
    const footer = document.getElementById('main-cart-footer');
    const items = document.getElementById('main-cart-items');
    const sections = [];

    if (items?.dataset?.id) {
      sections.push({
        id: 'main-cart-items',
        section: items.dataset.id,
        selector: '.js-contents-items',
      });
    }

    if (footer?.dataset?.id) {
      sections.push({
        id: 'main-cart-footer',
        section: footer.dataset.id,
        selector: '.js-contents-footer',
      });
    }

    sections.push({
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    });

    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshFooterSummary(sectionHtml) {
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const newSummary = doc.querySelector('#main-cart-footer .cart-subtotal-summary');
    const currentSummary = document.querySelector('#main-cart-footer .cart-subtotal-summary');

    if (newSummary && currentSummary) {
      currentSummary.replaceWith(newSummary.cloneNode(true));
      return true;
    }

    const newFooterContents = doc.querySelector('#main-cart-footer .js-contents-footer');
    const currentFooter = document.querySelector('#main-cart-footer .js-contents-footer');
    if (newFooterContents && currentFooter) {
      currentFooter.innerHTML = newFooterContents.innerHTML;
      return true;
    }

    return false;
  }

  function refreshCartSections(sections) {
    if (!sections) return;

    const promoPanel = document.querySelector('[data-po-cart-promo] .po-discount-panel');
    const promoToggle = document.querySelector('[data-po-cart-promo] .po-discount-toggle');
    const promoWasOpen = promoToggle?.getAttribute('aria-expanded') === 'true';

    getSectionsToRender().forEach(({ id, section, selector }) => {
      const html = sections[section];
      if (!html) return;

      const root = document.getElementById(id);
      if (!root) return;

      if (id === 'main-cart-footer' && selector === '.js-contents-footer') {
        refreshFooterSummary(html);
        return;
      }

      const target = root.querySelector(selector) || root;
      const inner = getSectionInnerHTML(html, selector);
      if (inner != null) target.innerHTML = inner;
    });

    document.dispatchEvent(new CustomEvent('po:cart:discount-updated'));
    window.poDiscountDropdownInit?.();
    bindPromoForm(document.querySelector('[data-po-cart-promo-form]'));

    if (promoWasOpen && promoPanel && promoToggle) {
      promoToggle.setAttribute('aria-expanded', 'true');
      promoPanel.removeAttribute('hidden');
      promoPanel.classList.add('open');
    }
  }

  function setFeedback(wrapper, activeKey) {
    if (!wrapper) return;

    FEEDBACK_KEYS.forEach((key) => {
      const el = wrapper.querySelector(`[data-po-cart-promo-feedback="${key}"]`);
      if (!el) return;
      el.style.display = activeKey === key ? '' : 'none';
    });
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getAppliedDiscountCodes(cart) {
    if (!cart) return [];

    const codes = [];

    (cart.cart_level_discount_applications || []).forEach((discount) => {
      if (discount.type === 'discount_code' && discount.title) {
        const title = discount.title.trim();
        if (title && !codes.some((c) => c.toLowerCase() === title.toLowerCase())) {
          codes.push(title);
        }
      }
    });

    (cart.discount_codes || []).forEach((discount) => {
      if (discount.code && discount.applicable !== false) {
        const code = discount.code.trim();
        if (code && !codes.some((c) => c.toLowerCase() === code.toLowerCase())) {
          codes.push(code);
        }
      }
    });

    return codes;
  }

  async function fetchCartJson() {
    const cartUrl = window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
    const response = await fetch(`${cartUrl}.js`);
    if (!response.ok) {
      throw new Error('Unable to read cart');
    }
    return response.json();
  }

  function mergeDiscountCodes(existingCodes = [], newCode = '') {
    const merged = [...existingCodes];
    const normalizedNew = newCode.trim();
    if (!normalizedNew) return merged;

    if (!merged.some((c) => c.toLowerCase() === normalizedNew.toLowerCase())) {
      merged.push(normalizedNew);
    }

    return merged;
  }

  function getRenderedDiscountCodes() {
    return Array.from(document.querySelectorAll('[data-po-cart-promo-codes] [data-discountcode]'))
      .map((node) => String(node.dataset.discountcode || node.textContent || '').trim())
      .filter(Boolean);
  }

  function publishAppliedState(codes) {
    document.dispatchEvent(
      new CustomEvent('po:cart-promo-code:state', {
        detail: {
          codes: Array.isArray(codes) ? codes : [],
        },
      })
    );
  }

  function publishCartDiscountSync(cart) {
    document.dispatchEvent(new CustomEvent('po:cart:discount-updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

    const codes = getAppliedDiscountCodes(cart);
    const csv = codes.length
      ? `,${codes.map((c) => c.toLowerCase()).join(',')},`
      : '';
    const previous = document.documentElement.dataset.poDkAppliedCodes || '';
    document.documentElement.dataset.poDkAppliedCodes = csv;

    if (csv !== previous) {
      document.dispatchEvent(
        new CustomEvent('po:dk:discount-codes-changed', { detail: { appliedCodes: csv } })
      );
    }

    publishAppliedState(codes);
    window.PoDkStorefrontPrices?.syncAppliedCodesFromCookies?.();
    window.PoDkStorefrontPrices?.refresh?.();
  }

  function renderDiscountTags(wrapper, codes) {
    const container = wrapper?.querySelector('[data-po-cart-promo-codes]');
    if (!container) return;

    container.innerHTML = '';

    codes.forEach((code) => {
      const tag = document.createElement('div');
      tag.className = 'limoniapps-discountninja-cartdiscountfield-discountcode';
      tag.dataset.discountcode = code;
      tag.innerHTML = `
        <span class="limoniapps-discountninja-cartdiscountfield-discountcode-code">${escapeHtml(code)}</span>
        <svg
          class="limoniapps-discountninja-cartdiscountfield-discountcode-close"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 13 13"
          role="button"
          tabindex="0"
          aria-label="Remove ${escapeHtml(code)}"
          data-po-cart-promo-remove="${escapeHtml(code)}"
        >
          <path
            d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55"
            stroke-width="2"
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
          ></path>
        </svg>
      `;
      container.appendChild(tag);
    });
  }

  function updateAppliedState(wrapper, cart) {
    const codes = getAppliedDiscountCodes(cart);
    renderDiscountTags(wrapper, codes);
    publishAppliedState(codes);

    if (codes.length) {
      setFeedback(wrapper, 'applied');
    } else {
      setFeedback(wrapper, null);
    }
  }

  function setLoading(wrapper, loading) {
    const applyBtn = wrapper?.querySelector('[data-po-cart-promo-apply]');
    const input = wrapper?.querySelector('[data-po-cart-promo-input]');

    if (applyBtn) applyBtn.disabled = loading;
    if (input) input.disabled = loading;

    if (loading) {
      setFeedback(wrapper, 'searching');
    }
  }

  function clearLoading(wrapper) {
    const applyBtn = wrapper?.querySelector('[data-po-cart-promo-apply]');
    const input = wrapper?.querySelector('[data-po-cart-promo-input]');
    if (applyBtn) applyBtn.disabled = false;
    if (input) input.disabled = false;
  }

  async function updateCartDiscount(discountCode) {
    const sections = getSectionsToRender().map((s) => s.section);
    const body = JSON.stringify({
      discount: discountCode,
      sections,
      sections_url: window.location.pathname,
    });

    const response = await fetch(`${window.routes.cart_update_url}`, {
      ...fetchConfig(),
      body,
    });

    const data = await response.json();

    if (data.status && data.status !== 200) {
      throw new Error(data.description || data.message || I18N.invalid_code);
    }

    if (data.errors) {
      throw new Error(
        typeof data.errors === 'string' ? data.errors : I18N.invalid_code || 'Invalid code'
      );
    }

    return data;
  }

  function resolveErrorFeedback(wrapper, cart, attemptedCode) {
    const normalized = (attemptedCode || '').trim().toLowerCase();
    const match = (cart?.discount_codes || []).find(
      (entry) => entry.code?.toLowerCase() === normalized
    );

    if (match && match.applicable === false) {
      setFeedback(wrapper, 'notapplied');
      return;
    }

    setFeedback(wrapper, 'notfound');
  }

  async function applyCode(wrapper) {
    const input = wrapper?.querySelector('[data-po-cart-promo-input]');
    const code = (input?.value || '').trim();

    if (!code) {
      setFeedback(wrapper, 'notfound');
      return;
    }

    setLoading(wrapper, true);

    try {
      const cartBefore = await fetchCartJson();
      const existingCodes = getAppliedDiscountCodes(cartBefore);
      const discountPayload = mergeDiscountCodes(existingCodes, code).join(',');

      const data = await updateCartDiscount(discountPayload);
      const appliedCodes = getAppliedDiscountCodes(data);
      const codeApplied = appliedCodes.some((c) => c.toLowerCase() === code.toLowerCase());

      if (!codeApplied) {
        if (
          appliedCodes.length === existingCodes.length &&
          existingCodes.some((c) => c.toLowerCase() === code.toLowerCase())
        ) {
          setFeedback(wrapper, 'applied');
        } else if (appliedCodes.length === existingCodes.length && existingCodes.length > 0) {
          setFeedback(wrapper, 'notcombinable');
        } else {
          publishAppliedState([]);
          resolveErrorFeedback(wrapper, data, code);
        }
        return;
      }

      refreshCartSections(data.sections);
      updateAppliedState(wrapper, data);
      publishCartDiscountSync(data);
      if (input) input.value = '';
    } catch (error) {
      setFeedback(wrapper, 'notfound');
    } finally {
      clearLoading(wrapper);
    }
  }

  async function removeCode(wrapper, codeToRemove = '') {
    setLoading(wrapper, true);

    try {
      let discountPayload = '';

      if (codeToRemove) {
        const cartBefore = await fetchCartJson();
        const remaining = getAppliedDiscountCodes(cartBefore).filter(
          (c) => c.toLowerCase() !== codeToRemove.trim().toLowerCase()
        );
        discountPayload = remaining.join(',');
      }

      const data = await updateCartDiscount(discountPayload);
      refreshCartSections(data.sections);
      updateAppliedState(wrapper, data);
      publishCartDiscountSync(data);

      if (!getAppliedDiscountCodes(data).length) {
        setFeedback(wrapper, null);
      }
    } catch (error) {
      setFeedback(wrapper, 'notapplied');
    } finally {
      clearLoading(wrapper);
    }
  }

  async function applyExternalCode(code) {
    const normalizedCode = String(code || '').trim();
    if (!normalizedCode) return false;

    const wrapper = document.querySelector('[data-po-cart-promo-form]');
    if (!wrapper) return false;

    const input = wrapper.querySelector('[data-po-cart-promo-input]');
    if (input) {
      input.value = normalizedCode;
    }

    await applyCode(wrapper);
    return true;
  }

  function bindPromoForm(wrapper) {
    if (!wrapper || wrapper.dataset.poPromoBound === 'true') return;
    wrapper.dataset.poPromoBound = 'true';

    const applyBtn = wrapper.querySelector('[data-po-cart-promo-apply]');
    const input = wrapper.querySelector('[data-po-cart-promo-input]');

    applyBtn?.addEventListener('click', () => applyCode(wrapper));

    input?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyCode(wrapper);
      }
    });

    wrapper.addEventListener('click', (event) => {
      const removeBtn = event.target.closest('[data-po-cart-promo-remove]');
      if (removeBtn) {
        event.preventDefault();
        const code =
          removeBtn.getAttribute('data-po-cart-promo-remove') ||
          removeBtn.closest('[data-discountcode]')?.dataset?.discountcode ||
          '';
        removeCode(wrapper, code);
      }
    });

    wrapper.addEventListener('keydown', (event) => {
      const removeBtn = event.target.closest('[data-po-cart-promo-remove]');
      if ((event.key === 'Enter' || event.key === ' ') && removeBtn) {
        event.preventDefault();
        const code =
          removeBtn.getAttribute('data-po-cart-promo-remove') ||
          removeBtn.closest('[data-discountcode]')?.dataset?.discountcode ||
          '';
        removeCode(wrapper, code);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-po-cart-promo-form]').forEach(bindPromoForm);
    publishAppliedState(getRenderedDiscountCodes());
  }

  document.addEventListener('po:url-promo:apply', (event) => {
    void applyExternalCode(event.detail?.promocode || event.detail?.code);
  });

  window.poCartPromoCodeApply = applyExternalCode;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
